import { format, formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';

// ----------------------------------------------------------------------

export function fDate(date: any) {
  return format(new Date(date), 'dd/MM/yyyy', { locale: ptBR });
}

export function fDateTime(date: any) {
  return format(new Date(date), 'dd/MM/yyyy HH:mm', { locale: ptBR });
}

export function fDateTimeSuffix(date: any) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fToNow(date: any) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true
  });
}
